import React, { Component } from "react";
import PropTypes, { number } from "prop-types";
import Modal from "../Modal/Modal";
import { formatPhone } from "../../../js/shared/utils";
import { phoneNumberMask, patternOnlyNumbers } from "../utils/masks";
import InputForm from "../../atoms/InputForm";
import Callout from "../Callout/Callout";
import { copyToClipboard } from "../../../../../max-checkout/src/shared/checkoutUtils";

const urlUpdatePhoneMultiplus =
	"https://www.pontosmultiplus.com.br/portal/pages/meusDados/MeusDados.html";

class ModalLatamPhone extends Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneModal: "",
			phoneModalInfo: undefined,
			valid: false,
			numberPage: 1,
			latamAccessed: false,
			updateLatamPhone: props.updateLatamPhone,
			notify: false
		};
	}

	close = () => {
		this.props.close();
		this.setState({
			phoneModal: "",
			numberPage: 1,
			latamAccessed: false,
			phoneModalInfo: undefined
		});
	};

	checkPhone(phone) {
		const { updateLatamPhone, phoneSugestion } = this.props;

		const phoneWithoutMask = phone
			.match(patternOnlyNumbers)
			.join("")
			.toString();

		if (
			(!updateLatamPhone && phone && phoneWithoutMask.length === 11) ||
			(updateLatamPhone && phone === formatPhone(phoneSugestion))
		) {
			this.setState({ valid: true });
			return true;
		}

		if (!phone) {
			this.setState({ valid: false });
			return false;
		} else {
			this.setState({ valid: false });
			return false;
		}
	}

	confirm = () => {
		this.setState(
			{
				valid: false,
				latamAccessed: false,
				numberPage: 1,
				phoneModalInfo: undefined,
				show: false
			},
			() => {
				const phoneInfo = this.state.phoneModal.match(patternOnlyNumbers)
					? this.state.phoneModal
						.match(patternOnlyNumbers)
						.join("")
						.toString()
					: "";
				this.props.confirm(phoneInfo);
				this.close();
			}
		);
	};

	onChangePhone = e => {
		this.checkPhone(e.target.value);
		this.setState({ phoneModalInfo: e.target.value });

		this.setState({
			phoneModal: e.target.value
		});
	};

	timeOutNotify = () => {
		setTimeout(() => {
			this.setState({ notify: true });
		}, 500);
		this.close;
		setTimeout(() => {
			this.setState({ notify: false });
		}, 4000);
	};

	render() {
		const { phoneSugestion, show } = this.props;
		const { phoneModal, valid, numberPage, phoneModalInfo, latamAccessed, notify } = this.state;

		const copyInfo = () => {
			copyToClipboard(phoneSugestion);
		};

		const nextNumber = add => {
			if (add) {
				if (numberPage === 2) {
					copyInfo();
					this.timeOutNotify();
				}
				if (numberPage < 3) {
					this.setState({ numberPage: numberPage + 1 });
				} else {
					this.confirm();
				}
			} else {
				if (numberPage !== 1) {
					this.setState({ numberPage: numberPage - 1 });
				}
			}
		};

		const changeLatamNumber = () => {
			this.setState({ latamAccessed: true });
			copyToClipboard(phoneSugestion);
			window.open(urlUpdatePhoneMultiplus, "_blank");
		};

		const validateModalMargin = () => {
			return numberPage === 3 && window.screen.width <= 320
				? !phoneModalInfo
					? 51
					: phoneModalInfo && phoneModalInfo !== formatPhone(phoneSugestion)
						? 6
						: 36
				: window.screen.width <= 320
					? 40
					: window.screen.width <= 390
						? 70
						: window.screen.width <= 767
							? 0
							: window.screen.width === 768
								? 50
								: window.screen.width === 1024 && numberPage === 1
									? 71
									: window.screen.width === 1024 && numberPage > 1
										? 40
										: window.screen.width <= 1023 && window.screen.height > 600
											? 120
											: window.screen.height <= 600
												? 0
												: window.screen.height / 5;
		};

		const validateModalHeight = () => {
			return numberPage === 1
				? window.screen.width <= 320
					? 474
					: window.screen.width <= 375
						? 473
						: window.screen.width <= 390
							? 455
							: window.screen.width <= 414
								? 439
								: window.screen.width <= 767
									? 397
									: 393
				: numberPage === 2 && window.screen.width >= 1024
					? 460
					: window.screen.width <= 320 && numberPage === 2
						? 470
						: window.screen.width <= 320 &&
							phoneModalInfo &&
							phoneModalInfo !== formatPhone(phoneSugestion) &&
							numberPage === 3
							? 555
							: phoneModalInfo &&
								phoneModalInfo === formatPhone(phoneSugestion) &&
								numberPage === 3 &&
								window.screen.width <= 320
								? 500
								: window.screen.width <= 320 && !phoneModalInfo && numberPage === 3
									? 500
									: window.screen.width <= 390 && !phoneModalInfo && numberPage === 3
										? 439
										: window.screen.width <= 412 && !phoneModalInfo && numberPage === 3
											? 478
											: phoneModalInfo &&
												phoneModalInfo === formatPhone(phoneSugestion) &&
												numberPage === 3 &&
												window.screen.width <= 390
												? 466
												: phoneModalInfo &&
													phoneModalInfo === formatPhone(phoneSugestion) &&
													numberPage === 3 &&
													window.screen.width <= 412
													? 452
													: window.screen.width <= 390 &&
														phoneModalInfo &&
														phoneModalInfo !== formatPhone(phoneSugestion) &&
														numberPage === 3
														? 507
														: window.screen.width <= 412 &&
															phoneModalInfo &&
															phoneModalInfo !== formatPhone(phoneSugestion) &&
															numberPage === 3
															? 512
															: window.screen.width <= 414 && numberPage === 3 && !phoneModal
																? 422
																: window.screen.width <= 767 && numberPage === 3 && !phoneModal
																	? 381
																	: window.screen.width <= 414 &&
																		numberPage === 3 &&
																		phoneModal === formatPhone(phoneSugestion)
																		? 449
																		: window.screen.width <= 767 &&
																			numberPage === 3 &&
																			phoneModal === formatPhone(phoneSugestion)
																			? 408
																			: window.screen.width <= 414 &&
																				numberPage === 3 &&
																				phoneModal !== formatPhone(phoneSugestion)
																				? 489
																				: window.screen.width <= 767 &&
																					numberPage === 3 &&
																					phoneModal !== formatPhone(phoneSugestion)
																					? 431
																					: window.screen.width <= 375 && numberPage === 2
																						? 589
																						: window.screen.width <= 390 && numberPage === 2
																							? 573
																							: window.screen.width <= 414 && numberPage === 2
																								? 555
																								: window.screen.width <= 767 && numberPage === 2
																									? 462
																									: window.screen.width <= 820 && numberPage === 2
																										? 456
																										: window.screen.width <= 912 && numberPage === 2
																											? 462
																											: window.screen.width < 768 && numberPage === 3
																												? 418
																												: window.screen.width === 768 && numberPage === 3 && !phoneModalInfo
																													? 380
																													: window.screen.width === 768 &&
																														numberPage === 3 &&
																														phoneModalInfo === formatPhone(phoneSugestion)
																														? 408
																														: window.screen.width === 768 &&
																															numberPage === 3 &&
																															phoneModalInfo !== formatPhone(phoneSugestion)
																															? 431
																															: window.screen.width === 1024 &&
																																numberPage === 3 &&
																																phoneModalInfo &&
																																phoneModalInfo !== formatPhone(phoneSugestion)
																																? 431
																																: phoneModalInfo &&
																																	phoneModalInfo !== formatPhone(phoneSugestion) &&
																																	numberPage === 3 &&
																																	window.screen.width <= 1366
																																	? 423
																																	: window.screen.width <= 1920 && numberPage === 3 && !phoneModalInfo
																																		? 381
																																		: window.screen.width <= 1920 &&
																																			numberPage === 3 &&
																																			phoneModalInfo !== formatPhone(phoneSugestion)
																																			? 431
																																			: window.screen.width <= 1920 &&
																																				numberPage === 3 &&
																																				phoneModalInfo === formatPhone(phoneSugestion)
																																				? 408
																																				: window.screen.width > 1366
																																					? 428
																																					: window.screen.width === 1024 && numberPage === 3 && !phoneModalInfo
																																						? 380
																																						: window.screen.width === 1366 && numberPage === 3 && !phoneModalInfo
																																							? 381
																																							: window.screen.width === 1366 &&
																																								numberPage === 3 &&
																																								!phoneModalInfo &&
																																								phoneModalInfo !== formatPhone(phoneSugestion)
																																								? 423
																																								: 408;
		};

		return (
			<>
				{notify && (
					<div className="modal-phone-latam--notify">
						<div>
							<Modal
								show={true}
								dontUseDefaultOption={true}
								title={<span id="notificationText">Número da Max copiado com sucesso!</span>}
								height={20}
								width={302}
								marginTop={1}
								id={"modalNotify"}
								idBackGround={"modalNotifyBackGround"}
							/>
						</div>
					</div>
				)}
				<Modal
					show={show}
					fixed
					height={validateModalHeight()}
					width={463}
					dontUseDefaultOption={true}
					borderRadius={16}
					marginTop={validateModalMargin()}
					title={
						<>
							<div className="modal-phone-latam--button-group-close">
								<button
									type="button"
									className="modal-phone-latam--button-close"
									onClick={this.close}
								>
									<i className="icon-close" />
								</button>
							</div>
							<div className="modal-phone-latam--title">
								<i className="icon-attention" /> <h5>Necessário atualização do número</h5>
							</div>
						</>
					}
					description={
						<div>
							{numberPage === 1 ? (
								<div>
									<p className="modal-phone-latam--bold-text">
										No momento da emissão de cada passagem, a Latam envia um código via SMS para o
										número de telefone celular cadastrado no seu programa Latam Pass.
									</p>
									<p className="modal-phone-latam--text">
										Para evitar entrarmos em contato com você a cada emissão de passagem com suas
										milhas, é necessário alterar o telefone celular do Latam Pass para um número da
										MaxMilhas. Assim, nós recebemos o código SMS e iremos agilizar suas vendas!
									</p>
									<p className="modal-phone-latam--bold-text">
										É seguro, simples e rápido! <br />
										Clique em "Próximo" para ver o passo a passo.
									</p>
									<p className="modal-phone-latam--text">Vamos lá?</p>
								</div>
							) : numberPage === 2 ? (
								<div>
									<p className="modal-phone-latam--text-step2">
										Para vender as milhas é <b>obrigatório</b> fazer o procedimento a seguir:
									</p>
									<p className="modal-phone-latam--bold-text">
										{window.screen.width <= 320
											? "1. Acesse o site do Latam Pass"
											: "1. Acesse o site do Latam Pass (basta clicar no botão abaixo)."}
									</p>
									<p className="modal-phone-latam--bold-text">
										2. No Latam Pass, clique em "Fazer login" e preencha os dados.
									</p>
									<p className="modal-phone-latam--bold-text">
										3. Clique em "Minha conta"
										{window.screen.width <= 320 ? "." : " (canto superior direito)."}
									</p>
									<p className="modal-phone-latam--bold-text">
										4. Clique em "Meu cadastro"
										{window.screen.width <= 320 ? "." : " (menu do lado esquerdo)."}
									</p>
									<p className="modal-phone-latam--bold-text">
										5. No campo "Telefone celular", digite o número{" "}
										<b className="modal-phone-latam--bold-number">{formatPhone(phoneSugestion)}</b>
									</p>
									{window.screen.width <= 320 ? (
										""
									) : (
										<p className="modal-phone-latam--bold-text">
											6. Clique em "Salvar" para finalizar.
										</p>
									)}

									<br />
									<button
										type="button"
										className={
											latamAccessed
												? "modal-phone-latam--clicked"
												: "modal-phone-latam--button-to-click"
										}
										onClick={() => changeLatamNumber()}
										data-action="update-phone-multiplus"
									>
										Alterar telefone no Latam Pass
									</button>
									<br />
									<br />
								</div>
							) : (
								<div>
									<p className="modal-phone-latam--bold-text">
										Ótimo! Você ja alterou o número para {formatPhone(phoneSugestion)}, só falta
										preencher o campo abaixo para confirmar este telefone celular da Max que você
										incluiu no Latam Pass.
									</p>

									<p
										className={
											window.screen.width <= 320
												? "modal-phone-latam--text-mobile"
												: "modal-phone-latam--text"
										}
									>
										Se você não fez o procedimento ou ainda está com seu número de telefone no Latam
										Pass, basta voltar para o passo anterior.
									</p>

									<InputForm
										autoFocus
										autoComplete="off"
										ref={input => {
											this.theInput = input;
											if (this.props.refInput) {
												this.props.refInput(input);
											}
										}}
										name={"phoneModal"}
										id="phoneModal"
										type="tel"
										onChange={this.onChangePhone}
										placeholder="Cole aqui o número de telefone"
										mask={phoneNumberMask}
										label="Telefone cadastrado no Latam Pass"
										data-action="login-offer-phone"
										className={
											phoneModalInfo === formatPhone(phoneSugestion)
												? "modal-phone-latam--inputFormSuccess"
												: "modal-phone-latam--inputForm"
										}
										value={phoneModal}
									/>

									<div className="modal-phone-latam--callout">
										{phoneModalInfo && phoneModalInfo !== formatPhone(phoneSugestion) ? (
											<Callout
												show={true}
												danger
												icon={"alert"}
												text={
													<span>
														O número de telefone não é o indicado pela MaxMilhas. Consulte novamente
														as instruções na tela anterior.
													</span>
												}
											/>
										) : (
											phoneModalInfo === formatPhone(phoneSugestion) && (
												<div className="modal-phone-latam--sucess">
													<i className="icon-check" />
													<p>Pronto! Telefone confirmado.</p>
												</div>
											)
										)}
									</div>
								</div>
							)}

							<br />
							<div className="modal-phone-latam--buttons-group">
								<div className="modal-phone-latam--icon-button-group">
									<button
										type="button"
										className="modal-phone-latam--back-button"
										onClick={() => {
											nextNumber(false);
										}}
									>
										<i className="icon-max-navigation-arrow-left" />
										<span>
											Voltar
										</span>
									</button>
								</div>
								{window.screen.width < 416 && (
									<div className="modal-phone-latam--page-counter">
										<b className="modal-phone-latam--super-bold">
											<p>{numberPage}</p>
										</b>
										<p>/ 3</p>
									</div>
								)}

								<button
									type="button"
									className={
										numberPage > 1
											? (numberPage === 2 && latamAccessed) || (numberPage === 3 && valid)
												? "modal-phone-latam--button-submit"
												: "modal-phone-latam--button-unavaliable"
											: "modal-phone-latam--button-submit"
									}
									onClick={
										numberPage > 1
											? (numberPage === 2 && latamAccessed) || (numberPage === 3 && valid)
												? () => {
													nextNumber(true);
												}
												: () => { }
											: () => {
												nextNumber(true);
											}
									}
								>
									{numberPage === 3 ? "Concluído" : "Próximo"}
								</button>
							</div>
						</div>
					}
				/>
			</>
		);
	}
}

ModalLatamPhone.propTypes = {
	phone: PropTypes.string,
	phoneSugestion: PropTypes.string,
	confirm: PropTypes.func.isRequired,
	close: PropTypes.func,
	show: PropTypes.bool
};

export default ModalLatamPhone;
